/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./virtualDevices.vue?vue&type=template&id=24bbb8e8&scoped=true"
import script from "./virtualDevices.vue?vue&type=script&lang=js"
export * from "./virtualDevices.vue?vue&type=script&lang=js"
import style0 from "./virtualDevices.vue?vue&type=style&index=0&id=24bbb8e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bbb8e8",
  null
  
)

export default component.exports